import classNames from 'classnames';

import type {FilterObject} from 'nutshell-core/types';

import {EngagementReport} from '../../ui/reports/engagement/engagement-report';
import {getExportTypes} from '../../ui/reports/report-constants';
import {ReportControlsContainer} from '../../ui/reports/report-controls-container';
import {shouldShowReportControls} from '../../ui/reports/report-helpers';
import {ReportTitleBar} from '../../ui/reports/report-title-bar';
import type {ReportURLParams} from '../../ui/reports/report-types';
import {ENGAGEMENT} from '../../ui/reports/report-types';

type Props = {
    urlParams: ReportURLParams<'leads'>;
    activeFilters: FilterObject[];
    onParamChange: () => void;
    onParamPush: () => void;
};

export function EngagementReportEmbedded(props: Props) {
    const {urlParams, activeFilters, onParamChange, onParamPush} = props;

    return (
        <div className={classNames('routed-report-content')}>
            <ReportTitleBar
                reportKey={ENGAGEMENT}
                urlParams={urlParams}
                hasActionButton={Boolean(getExportTypes(ENGAGEMENT).length)}
                onParamChange={onParamChange}
            />
            {shouldShowReportControls(ENGAGEMENT) && (
                <ReportControlsContainer
                    reportKey={ENGAGEMENT}
                    activeFilters={activeFilters}
                    reportParams={urlParams.report}
                    onParamChange={onParamChange}
                />
            )}
            <div
                className={classNames('routed-report-inner-container', {
                    'routed-report-inner-container--no-controls':
                        !shouldShowReportControls(ENGAGEMENT),
                })}
            >
                <EngagementReport
                    reportKey={ENGAGEMENT}
                    activeFilters={activeFilters}
                    onParamChange={onParamChange}
                    onParamPush={onParamPush}
                    urlParams={urlParams}
                />
            </div>
        </div>
    );
}
